
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44.8","height":"37.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"フッター　アポ一覧","fill":"#6d6c6f"}},[_c('text',{attrs:{"transform":"translate(.4 36.5)","stroke":"#6d6c6f","stroke-width":".4","font-size":"11","font-family":"HiraKakuProN-W3, Hiragino Kaku Gothic ProN"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('アポ一覧')])]),_c('path',{attrs:{"d":"M31.9 16V7h-14v9h14m0-14a2 2 0 012 2v12a2 2 0 01-2 2h-14a2 2 0 01-2-2V4a2 2 0 012-2h1V0h2v2h8V0h2v2h1m-18 18h14v2h-14a2 2 0 01-2-2V8h2v12m16-6h-4v-4h4z"}})])])
          )
        }
      }
    